"use client";

import { THomeBentoGridSection } from "@shared/cms";
import { BentoCard } from "@shared/ui";
import { cn } from "@ubud-ui/react-ui-kit";

export function HomeBentoGridSection({ colSize, backgroundColor, cards }: THomeBentoGridSection) {
  const backgroundVariants: Record<"gray" | "white", string> = {
    gray: "bg-gray-50",
    white: "bg-white",
  };

  const colSizeVariants: Record<"one" | "two", string> = {
    one: "grid-cols-1",
    two: "grid-cols-1 md:grid-cols-2",
  };

  if (!cards || (cards && cards.length <= 0)) {
    return <></>;
  }

  return (
    <section className={cn("py-14 md:py-24 md:mt-10", backgroundVariants[backgroundColor])}>
      <div className="container">
        <div className={cn("grid gap-6", colSizeVariants[colSize])}>
          {cards.map((card) => {
            return <BentoCard key={card.id} {...card} />;
          })}
        </div>
      </div>
    </section>
  );
}
